import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const ModernLoader = ({ message = "Loading...", size = 40 }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "200px",
        gap: 3,
      }}
    >
      <Box
        sx={{
          position: "relative",
          display: "inline-flex",
        }}
      >
        <CircularProgress
          size={size}
          thickness={4}
          sx={{
            color: "#667eea",
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress
            variant="determinate"
            value={100}
            size={size - 8}
            thickness={2}
            sx={{
              color: "rgba(102, 126, 234, 0.2)",
              position: "absolute",
            }}
          />
        </Box>
      </Box>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          fontWeight: 500,
          fontSize: "1rem",
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default ModernLoader;
